import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TripLandingPageTrendingDestinationsCarousel from './TripLandingPageTrendingDestinationsCarousel'
import { useTrendingDestinations } from './useTripLandingPageTrendingDestinations'
import type { TrendingDestination } from 'home/components/TrendingDestinations/constants'
import { FormattedMessage } from 'react-intl'

const SectionContainer = styled(VerticalSpacer)`
  padding-top: ${rem(64)};
  padding-bottom: ${rem(40)};
`

export interface CityTrendingDestination extends TrendingDestination {
  country?: string
}

export const destinations: Array<CityTrendingDestination> = [
  {
    destinationId: 'le_425f0cea87a40c5a8860e3db7c918c4e',
    imageId: 'hotel-destination-canggu',
    name: 'Canggu',
    url: '/search/hotels?destinationId=le_7cba87f571a31baf11325f462fbdcf14&destinationName=Canggu',
    country: 'Indonesia',
  },
  {
    destinationId: 'le_d47bb339212ddfab0fadd99d492a5fc3',
    imageId: 'hotel-destination-phuket',
    name: 'Phuket',
    url: '/search/hotels?destinationId=le_7cba87f571a31baf11325f462fbdcf14&destinationName=Phuket',
    country: 'Thailand',
  },
  {
    destinationId: 'le_790d9f1f52e10ef90ede8efcf7f3c078',
    imageId: 'hotel-destination-seminyak',
    name: 'Seminyak',
    url: '/search/hotels?destinationId=le_7cba87f571a31baf11325f462fbdcf14&destinationName=Seminyak',
    country: 'Indonesia',
  },
  {
    destinationId: 'le_7f7ed8ecfca9e17696ff654508efd86a',
    imageId: 'hotel-destination-ubud',
    name: 'Ubud',
    url: '/search/hotels?destinationId=le_7cba87f571a31baf11325f462fbdcf14&destinationName=Ubud',
    country: 'Indonesia',
  },
  {
    destinationId: 'le_bac732346917b0a1231354ef55faf00a',
    imageId: 'krvovndggw4zalo1kgo8',
    name: 'Gold Coast',
    url: '/search/hotels?destinationId=le_7cba87f571a31baf11325f462fbdcf14&destinationName=Gold Coast',
    country: 'Australia',
  },
  {
    destinationId: 'le_678c61ac5b4f91ca86e112fc50e63766',
    imageId: 'hotel-destination-sydney',
    name: 'Sydney',
    url: '/search/hotels?destinationId=le_7cba87f571a31baf11325f462fbdcf14&destinationName=Sydney',
    country: 'Australia',
  },
  {
    destinationId: 'le_bd4c9ab730f5513206b999ec0d90d1fb',
    imageId: 'b4u5c9v9eplflpfjohz8',
    name: 'Singapore',
    url: '/search/hotels?destinationId=le_7cba87f571a31baf11325f462fbdcf14&destinationName=Singapore',
    country: 'Singapore',
  },
  {
    destinationId: 'le_15fa44474c92da27cf2125373356db4c',
    imageId: 'asgz0fkt6cf311m98rq',
    name: 'Melbourne',
    url: '/search/hotels?destinationId=le_15fa44474c92da27cf2125373356db4c&destinationName=Melbourne',
    country: 'Australia',
  },
  {
    destinationId: 'le_43baa6762fa81bb43b39c62553b2970d',
    imageId: 'eoo7x60icwbgndyc1wcge',
    name: 'Dubai',
    url: '/search/hotels?destinationId=le_43baa6762fa81bb43b39c62553b2970d&destinationName=Dubai',
    country: 'United Arab Emirates',
  },
]

function TripLandingPageTrendingDestinations() {
  const { finalDestinations, fetchingDestinations } = useTrendingDestinations(destinations)

  return (
    <SectionContainer gap={32}>
      <LayoutContainer>
        <Heading variant="heading2">
          <FormattedMessage
            id="x9m0W7Qf/n"
            defaultMessage="Start with a <i>trending destination</i>"
            description="Heading for trending destinations section"
            values={{
              i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
            }}
          />
        </Heading>
      </LayoutContainer>
      <TripLandingPageTrendingDestinationsCarousel
        fetchingDestinations={fetchingDestinations}
        trendingDestinations={finalDestinations}
      />
    </SectionContainer>
  )
}

export default TripLandingPageTrendingDestinations
